import FormRow from 'components/forms/FormRow';
import SelectInput from 'components/forms/inputs/rhf-inputs/SelectInput';
import InfoTooltip from 'components/InfoTooltip';
import { getValidOptionsFromClassifier } from 'utils/formUtil';
import { ContactFormState } from './useContactForm';

/** Segment and service level, the last row of both the person and the company details. */
export const SegmentFields = ({ form }: { form: ContactFormState }): JSX.Element => {
    const { control, setValue } = form.methods;
    const { classifiers, hasUpdateSegmentPermission } = form;

    return (
        <FormRow>
            <SelectInput
                setValue={setValue}
                control={control}
                label="contacts.segment-type"
                placeholder="contacts.segment-type"
                name="segmentType"
                options={getValidOptionsFromClassifier<string, string>(classifiers['SEGMENT_TYPE']) ?? []}
                getOptionLabel="label"
                getOptionIdentifier="value"
                sortDirection="asc"
                tooltip={<InfoTooltip text="contacts.tooltips.segment-type" />}
                disabled={!hasUpdateSegmentPermission}
            />
            <SelectInput
                setValue={setValue}
                control={control}
                label="contacts.service-level-type"
                placeholder="contacts.service-level-type"
                name="serviceLevelType"
                options={getValidOptionsFromClassifier<string, string>(classifiers['SERVICE_LEVEL_TYPE']) ?? []}
                getOptionLabel="label"
                getOptionIdentifier="value"
                sortDirection="asc"
                tooltip={<InfoTooltip text="contacts.tooltips.service-level-type" />}
            />
        </FormRow>
    );
};
